import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import actions from './actions'
import getters from './getters'
import mutations from './mutations'

import AdminModule from './Admin'
import InstructorModule from './Instructor'
import StudentModule from './Student'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    admin: AdminModule,
    instructor: InstructorModule,
    student: StudentModule
  },
  state: {
    token: '',
    userInfo: null,
    isLoggedIn: false,
    sidebarItems: null,
    userDetails: {}
  },
  actions,
  mutations,
  getters,
  plugins: [createPersistedState({
    paths: ['token']
  })]
})


// WEBPACK FOOTER //
// ./src/store/index.js